import type { Entry, Fixture } from '@h2h/shared';
import { draftToWin, isCardStarted, toCard, type DraftCard } from './picks';
import { pickOutcome } from './pickOutcome';

/** Aggregate slate read for the Compete hero once any built card's match is under way. */
export interface SlateLiveStats {
  hasStarted: boolean;
  banked: number;
  inPlay: number;
  remainingToWin: number;
  settledCount: number;
  liveCount: number;
}

export function computeSlateLiveStats(
  cards: DraftCard[],
  fixtures: Fixture[],
  entry: Entry | null | undefined,
  now: number
): SlateLiveStats {
  const fixtureById = new Map(fixtures.map((f) => [f.fixtureId, f]));
  let banked = 0;
  let inPlay = 0;
  let remainingToWin = 0;
  let settledCount = 0;
  let liveCount = 0;
  let hasStarted = false;

  for (const card of cards.filter(isCardStarted)) {
    const f = fixtureById.get(card.fixtureId);
    if (!f) continue;

    const kickedOff = f.status !== 'SCHEDULED' || now >= f.kickoffAt;
    if (kickedOff) hasStarted = true;

    const entryPred = entry?.predictions.find((p) => p.fixtureId === card.fixtureId);
    const pred = entryPred ?? toCard(card);
    if (!pred) continue;

    if (f.status === 'SETTLED' || f.status === 'VOID') {
      settledCount++;
      const outcome = pickOutcome(pred, f);
      if (outcome && !outcome.live) banked += outcome.points;
    } else if (f.status === 'LIVE') {
      liveCount++;
      const outcome = pickOutcome(pred, f);
      if (outcome) inPlay += outcome.points;
    } else if (f.status === 'SCHEDULED' && now < f.kickoffAt) {
      remainingToWin += draftToWin(card);
    }
  }

  return { hasStarted, banked, inPlay, remainingToWin, settledCount, liveCount };
}
